import i18n from 'i18next';
import {initReactI18next} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

// Prefixe de deploiement : '' en dev, '/app' en prod (derriere nginx).
// Sans ca : (1) les traductions sont cherchees a /locales/... au lieu de /app/locales/...
//           (2) le detecteur 'path' lit "app" comme langue au lieu de "en".
const BASE_PATH = process.env.REACT_APP_BASE_PATH || "";

// Langues ecrites de droite a gauche
const RTL_LANGUAGES = ["ar", "he", "fa"];

// Pose lang et dir sur <html> (lecteurs d'ecran, CSS :lang() / [dir="rtl"]).
// Le code est ramene a la langue seule : "tr-TR" -> "tr", "zh-CN" -> "zh".
const applyDocumentLanguage = (lng) => {
    // Pas de document (rendu serveur, test en env node) : rien a faire
    if (typeof document === "undefined" || !document.documentElement) return;

    const resolved = String(lng || i18n.language || "en").split("-")[0].toLowerCase();
    if (!resolved) return;

    document.documentElement.lang = resolved;
    document.documentElement.dir = RTL_LANGUAGES.includes(resolved) ? "rtl" : "ltr";
};

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        preload: ['en'],
        load: 'languageOnly',
        fallbackLng:'en',
        debug: false,
        lowerCaseLng: true,
        backend: {
            loadPath: `${BASE_PATH}/locales/{{lng}}/{{ns}}.json`
        },
        detection: {
            order: ['path', 'localStorage'],
            lookupFromPathIndex: BASE_PATH ? 1 : 0
        }
    });

// A chaque changement de langue (init comprise, le cas echeant)
i18n.on("languageChanged", applyDocumentLanguage);
applyDocumentLanguage(i18n.language);

export default i18n;
